module.exports = __webpack_public_path__ + "static/media/GH3.910a33b6.jpg";